var slide_product_cart = {
  next: async function (e) {
    e.disabled = true;
    this.swiperElement = e.parentNode.parentNode.querySelector(
      ".card__media_swiper"
    );
    await this.slide("+");
    e.disabled = false;
  },
  prev: async function (e) {
    e.disabled = true;
    this.swiperElement = e.parentNode.parentNode.querySelector(
      ".card__media_swiper"
    );
    await this.slide("-");
    e.disabled = false;
  },
  swiperElement: null,
  slide: function (operator) {
    if (!this.swiperElement) return;

    const iframe_video = this.swiperElement.querySelector("iframe");
    if (!!iframe_video && iframe_video?.src.indexOf("playvideo") == -1) {
      iframe_video.src += "&playvideo=1";
    }

    return new Promise((res) => {
      this.swiperElement.scrollBy({
        left: eval(operator + this.swiperElement.clientWidth),
        behavior: "smooth",
      });
      res();
    });
  },
  registerEvents: function () {
    // Register new event listeners
    document
      .querySelectorAll(".product_card_slide_button.prev")
      .forEach((p) => {
        if (!p) return;
        p.addEventListener("click", function (e) {
          e.stopImmediatePropagation();
          slide_product_cart.prev(this);
        });
      });
    document
      .querySelectorAll(".product_card_slide_button.next")
      .forEach((n) => {
        if (!n) return;
        n.addEventListener("click", function (e) {
          e.stopImmediatePropagation(e);
          slide_product_cart.next(this);
        });
      });
  },
};

slide_product_cart.registerEvents();

if (window.matchMedia("(max-width:768px)").matches) {
  document.querySelectorAll(".card__media_swiper").forEach((card_swiper) => {
    if (!card_swiper) return;
    card_swiper.addEventListener("scroll", (_) => {
      const iframe_video = card_swiper.querySelector("iframe");
      if (!!iframe_video && iframe_video?.src.indexOf("playvideo") == -1) {
        iframe_video.src += "&playvideo=1";
      }
    });
  });
}
